import { render, staticRenderFns } from "./ApplicationLoginEmailCard.vue?vue&type=template&id=148f4954&scoped=true&"
import script from "./ApplicationLoginEmailCard.vue?vue&type=script&lang=js&"
export * from "./ApplicationLoginEmailCard.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationLoginEmailCard.vue?vue&type=style&index=0&id=148f4954&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148f4954",
  null
  
)

export default component.exports